import apiClient from '../lib/api-client';

const buildFormData = (payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    formData.append(key, value);
  });
  return formData;
};

export const beneficiaryService = {
  addBeneficiary: async ({
    fullName,
    relationship,
    birthDate,
    percAlloc,
    address,
  }) => {
    const formData = buildFormData({
      FullName: fullName,
      Relationship: relationship,
      birth_date: birthDate,
      perc_alloc: percAlloc,
      address,
    });

    const response = await apiClient.post('/beneficiary/update', formData);
    return response.data;
  },
  updateBeneficiary: async ({
    beneficiaryId,
    fullName,
    relationship,
    birthDate,
    percAlloc,
    address,
  }) => {
    if (!beneficiaryId) {
      throw new Error('Beneficiary ID is required for updates.');
    }

    const formData = buildFormData({
      beneficiary_id: beneficiaryId,
      FullName: fullName,
      Relationship: relationship,
      birth_date: birthDate,
      perc_alloc: percAlloc,
      address,
    });

    const response = await apiClient.post('/beneficiary/update', formData);
    return response.data;
  },
  deleteBeneficiary: async ({ beneficiaryId }) => {
    if (!beneficiaryId) {
      throw new Error('Beneficiary ID is required for deletion.');
    }
    const formData = buildFormData({ beneficiary_id: beneficiaryId });
    const response = await apiClient.post('/delete/beneficiary', formData);
    return response.data;
  },
};
